<template>
    <card-normal v-if="props.contactId" without-padding>
        <template #header>
            <card-section area="card-header">
                <text-heading sub>
                    Gekoppelde objecten
                </text-heading>
            </card-section>
        </template>
        <template #default>
            <woon-objecten-list :wonen-objecten="wonenObjecten" />
        </template>
    </card-normal>
</template>

<script setup lang="ts">
    import { CardNormal, CardSection, TextHeading } from '@keyvue/one-ui';
    import WoonObjectenList from '@/realworks/components/list/WoonObjectenList.vue';
    import type { ContactId, LeadId } from '@keyvue/one-api-client';
    import { RealworksAPI, RealworksWonenObject } from '@keyvue/one-api-client-legacy';
    import { ref } from 'vue';
    import type { Ref } from 'vue';

    interface Props {
        contactId: ContactId;
        leadId?: LeadId;
    }

    const props = defineProps<Props>();

    const wonenObjecten: Ref<RealworksWonenObject[]> = ref([]);

    if (props.leadId === undefined) {
        wonenObjecten.value = await RealworksAPI.getRealworksWonenObjecten(props.contactId.value);
    } else {
        wonenObjecten.value = await RealworksAPI.getRealworksWonenObjecten(props.contactId.value, props.leadId.value);
    }
</script>
